import { Box, Typography } from "@mui/material"

const PERIOD_MAP = {
    H: "Hour",
    D: "Day",
    W: "Week",
    M: "Month",
    Y: "Year",
    U: "Unknown",
}

export function FrequencyLabel({ frequency }) {
    if (!frequency) return null
    const periodChar = frequency.period === "Unknown" ? "U" : frequency.period?.[0] || "U"
    const label = `${frequency.interval}${periodChar}`
    return (
        <Box borderRadius={1} p={0.5} pl={1} pr={1}>
            <Typography variant="body2" component="span">
                {label}
            </Typography>
        </Box>
    )
}

export function parseFrequencyCode(code) {
    if (!code) return null
    const match = code.match(/^(\d+)([HDWMYU])$/i)
    if (!match) return null
    return { interval: parseInt(match[1], 10), period: PERIOD_MAP[match[2].toUpperCase()] || "Unknown", code }
}
